"use client";

import Image from "next/image";
import stickerSquareSimple from "@/assets/svgs/tami-square-simple.svg";
import { cn } from "@/lib/utils";
import { HOME_COPY } from "../../home.copy";

interface NavigationButtonProps {
  children?: React.ReactNode;
  label?: string;
  href?: string;
  onClick?: () => void;
  variant?: "glass" | "light";
  className?: string;
}

/**
 * Botão de navegação com estilo glass ou light
 */
function NavigationButton({ 
  children,
  label, 
  href, 
  onClick, 
  variant = "glass",
  className 
}: NavigationButtonProps) {
  const buttonClasses = cn(
    "rounded-full px-6 py-3 text-sm font-bold whitespace-nowrap",
    "transition-all duration-200 hover:scale-105",
    variant === "glass" && "relative backdrop-blur-xl bg-black/30 text-white border border-white/10 shadow-[0_8px_32px_0_theme(colors.white/10%)] before:absolute before:inset-0 before:rounded-full before:bg-gradient-to-br before:from-white/5 before:via-white/0 before:to-transparent before:pointer-events-none hover:bg-black/40 hover:border-white/20 hover:shadow-[0_8px_32px_0_theme(colors.white/15%)] transition-all duration-300",
    variant === "light" && "bg-tami-light text-black border border-black/10 hover:bg-tami-light-hover-soft flex items-center gap-2",
    className
  );

  const baseStyles: React.CSSProperties = variant === "glass"
    ? {
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
      }
    : {};

  const content = children || label;

  if (href) {
    return (
      <a 
        href={href} 
        className={buttonClasses}
        style={baseStyles}
      >
        {content}
      </a>
    );
  }

  return (
    <button 
      className={buttonClasses}
      style={baseStyles}
      onClick={onClick}
    >
      {content}
    </button>
  );
}

interface NavigationButtonsProps {
  onRouteClick?: (route: string) => void;
  className?: string;
}

/**
 * Componente de botões de navegação do header
 * Estilo glass escuro + botão especial light com ícone
 */
export function NavigationButtons({ onRouteClick, className }: NavigationButtonsProps) {
  const copy = HOME_COPY.navigationButtons;
  const handleClick = (route: string) => {
    if (onRouteClick) {
      onRouteClick(route);
    } else {
      console.log(`Navegando para: ${route}`);
    }
  };

  return (
    <div className={cn("flex flex-wrap justify-center gap-2 md:gap-3", className)}>
      <NavigationButton 
        label={copy.content} 
        onClick={() => handleClick("/conteudo")}
      />
      <NavigationButton 
        label={copy.finances} 
        onClick={() => handleClick("/financas")}
      />
      <NavigationButton 
        label={copy.agenda} 
        onClick={() => handleClick("/agenda")}
      />
      <NavigationButton 
        label={copy.team} 
        onClick={() => handleClick("/equipe")}
      />
      <NavigationButton 
        variant="light"
        onClick={() => handleClick("/sign")}
      >
        <Image
          src={stickerSquareSimple}
          alt={copy.iconAlt}
          width={20}
          height={20}
          className="object-contain"
        />
        <span>{copy.createAccount}</span>
      </NavigationButton>
    </div>
  );
}
